import {
  adresseSchema,
  AdresseFormValue,
  PrivatUnternehmenFormValue,
  privatUnternehmenKontaktdatenSchema,
} from './common-vertragspartner.schema';
import { apply, applyWhenValue, schema } from '@angular/forms/signals';

export interface BisherigerVertragspartnerFormValue {
  vertragspartnerBekanntheit: 'known' | 'unknown';
  privatUnternehmen: PrivatUnternehmenFormValue;
  adresse: AdresseFormValue | null;
}

export const bisherigerVertragspartnerSchema = schema<BisherigerVertragspartnerFormValue>(path => {
  apply(path.privatUnternehmen, privatUnternehmenKontaktdatenSchema);
  applyWhenValue(path.adresse, value => value !== null, adresseSchema);
});
